import { z } from "zod";
import { planEnum } from "./enums.js";

export const tenantSchema = z.object({
  id: z.string().uuid(),
  name: z.string().min(1),
  plan: planEnum,
  settings: z.record(z.string(), z.unknown()).default({}),
  createdAt: z.date(),
});

export type Tenant = z.infer<typeof tenantSchema>;
